import { useContext, useEffect, useState } from "react";
import { Props } from "./AccordionDetailsProps";
import MainContext from "../../../context/mainContext";
import { ISummaryApproverModel } from "../../../models/summary.model";
import summaryService from "../../../services/summary.service";
import SpinnerArea from "../../../components/SpinnerArea";
import { Box } from "@mui/material";
import styles from "./AccordionDetails.module.scss";
import Empty from "./Empty";
import { t } from "i18next";
import DataTable from "../../../components/Table";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import IconTooltip from "../../../components/IconTooltip";

const SummaryDraftApproval: React.FC<Props & { isFinal?: boolean }> = ({ publicationId, expanded, isFinal }) => {
  const { service } = useContext(MainContext);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [approvalData, setApprovalData] = useState<ISummaryApproverModel[]>();

  const columns: GridColDef[] = [
    {
      field: "approverName",
      headerName: t("designatedApprover")!,
      sortable: false,
      width: 200,
    },
    {
      field: "date",
      headerName: t("date")!,
      sortable: false,
      width: 120,
      renderCell: (params) => moment(params.row.date).format("MM/DD/YYYY"),
    },
    {
      field: "status",
      headerName: t("status")!,
      sortable: false,
      width: 120,
      renderCell: (params) => {
        return params.row.status === "Completed" ? (
          params.row.isApproved ? (
            t("approved")
          ) : (
            t("declined")
          )
        ) : (
          <>
            {params.row.status}{" "}
            {params.row.status === "Pending" && params.row.dueDate && (
              <IconTooltip title={t("deadlineTooltip", { dueDate: moment(params.row.dueDate).format("MM/DD/yyyy") })} />
            )}
          </>
        );
      },
    },
    {
      field: "comments",
      headerName: t("comments")!,
      sortable: false,
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        return <p>{params.row.comments}</p>;
      },
    },
  ];

  useEffect(() => {
    let active = true;

    if (active && expanded && !loaded) {
      service(() => summaryService.approvers(publicationId, isFinal!), {
        loader: setLoading,
        callback: (data) => {
          setApprovalData(data);
          setLoaded(true);
        },
      });
    }

    return () => {
      active = false;
    };
  }, [expanded, loaded, publicationId, isFinal, service]);

  return (
    <SpinnerArea loading={loading}>
      {approvalData && approvalData.length > 0 ? (
        <Box className={styles.review}>
          <DataTable<ISummaryApproverModel>
            rows={approvalData}
            columns={columns}
            emptyMessage={t("noApproversAssigned")}
            loading={false}
            autoHeight
            rowAutoHeight
          />
        </Box>
      ) : (
        <Empty messge={t("noApproversAssigned")} />
      )}
    </SpinnerArea>
  );
};

export default SummaryDraftApproval;
